const mutations = {
  SET_JOIN_PROCEDURES(state, payload) {
    state.joinProcedures = payload;
  },
  SET_JOIN_PROCEDURE(state, payload) {
    state.joinProcedure = payload;
  },
};

export default mutations;
